export class DropdownDimensions {
  constructor(public left: number, public top: number, public width: number) {}
}
